export const projects = [
  {
    id: 'bitlocker-manager',
    title: 'BitLocker Yönetim Aracı',
    description: 'Kurumsal ortamlarda BitLocker şifreleme anahtarlarını merkezi olarak yönetmek için geliştirilmiş açık kaynak araç. Entra ID entegrasyonu ile güvenli anahtar saklama.',
    image: 'https://public.readdy.ai/ai/img_res/da810a1aa53765a7c9458cd528d8d57f.jpg',
    tags: ['BitLocker', 'PowerShell', 'Entra ID', 'Şifreleme'],
    github: 'https://github.com/msecuritylabs/bitlocker-manager',
    demo: '#',
    featured: true
  },
  {
    id: 'intune-vault',
    title: 'Intune Configuration Vault',
    description: 'Microsoft Intune yapılandırmalarını JSON formatında yedeklemek ve geri yüklemek için PowerShell tabanlı araç. Politika versiyonlama ve karşılaştırma özellikleri.',
    image: 'https://readdy.ai/api/search-image?query=Cloud%20configuration%20management%20interface%20with%20vault%20concept%20showing%20policy%20backup%20system%20teal%20and%20gray%20color%20scheme%20modern%20enterprise%20software%20design%20clean%20white%20background%20professional%20tech%20illustration&width=800&height=600&seq=intune1&orientation=landscape',
    tags: ['Intune', 'PowerShell', 'Graph API', 'Backup'],
    github: 'https://github.com/msecuritylabs/intune-vault',
    demo: '#',
    featured: true
  },
  {
    id: 'sentinel-automation',
    title: 'Sentinel Otomasyon Kütüphanesi',
    description: 'Microsoft Sentinel için hazır playbook şablonları ve otomasyon senaryoları. Olay müdahale süreçlerini hızlandıran Logic Apps entegrasyonları.',
    image: 'https://readdy.ai/api/search-image?query=Security%20operations%20center%20automation%20dashboard%20with%20workflow%20diagrams%20and%20alert%20management%20purple%20and%20blue%20gradient%20modern%20cybersecurity%20interface%20clean%20white%20background%20professional%20design&width=800&height=600&seq=sentinel1&orientation=landscape',
    tags: ['Sentinel', 'Logic Apps', 'SOAR', 'KQL'],
    github: 'https://github.com/msecuritylabs/sentinel-automation',
    demo: '#',
    featured: false
  },
  {
    id: 'defender-reports',
    title: 'Defender Raporlama Aracı',
    description: 'Microsoft Defender for Endpoint verilerinden otomatik güvenlik raporları oluşturan araç. Executive summary ve teknik detay raporları.',
    image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20reporting%20dashboard%20with%20charts%20and%20threat%20analytics%20red%20and%20black%20color%20scheme%20modern%20security%20software%20interface%20clean%20white%20background%20professional%20enterprise%20design&width=800&height=600&seq=defender1&orientation=landscape',
    tags: ['Defender', 'PowerBI', 'Reporting', 'API'],
    github: 'https://github.com/msecuritylabs/defender-reports',
    demo: '#',
    featured: false
  }
];

export const githubProjects = [
  {
    id: 'intune-vault',
    name: 'IntuneVault',
    description: 'Comprehensive Intune management platform with real-time monitoring, policy analytics, and advanced security insights.',
    url: 'https://www.intune-vault.com/',
    stars: 0,
    forks: 0,
    language: 'Web Application',
    version: 'v8.3',
    versionLabel: 'Stable',
    isWebApp: true,
    features: [
      { icon: 'ri-shield-check-line', title: 'Policy Analytics', description: 'Real-time policy monitoring and compliance tracking' },
      { icon: 'ri-git-compare-line', title: 'Snapshot Compare', description: 'Compare policy states across different time periods' },
      { icon: 'ri-file-search-line', title: 'Audit Logs', description: 'Kim, neyi, ne zaman değiştirdi? Tek tık uzağınızda' },
      { icon: 'ri-history-line', title: 'Legacy Support', description: 'v8.0 & v8.1 verileri %100 uyumlu, otomatik taşıma' },
      { icon: 'ri-bar-chart-2-line', title: 'Advanced Reports', description: 'Detailed security and compliance reporting' },
      { icon: 'ri-cloud-line', title: 'Graph API', description: 'Direct Microsoft Graph API integration' },
      { icon: 'ri-lock-password-line', title: 'Secure Access', description: 'Microsoft SSO with role-based permissions' },
    ],
    trustBadges: [
      { icon: 'ri-microsoft-line', label: 'Microsoft SSO' },
      { icon: 'ri-shield-keyhole-line', label: 'Zero Trust' },
      { icon: 'ri-server-line', label: 'Graph API' },
    ],
    dashboardStats: [
      { label: 'Total Policies', icon: 'ri-file-list-3-line' },
      { label: 'Assigned', icon: 'ri-check-double-line' },
      { label: 'Unassigned', icon: 'ri-alert-line' },
      { label: 'Security', icon: 'ri-shield-line' },
      { label: 'Audit Events', icon: 'ri-file-search-line' },
      { label: 'Snapshots', icon: 'ri-camera-line' },
    ],
    dashboardTabs: [
      { icon: 'ri-dashboard-3-line', label: 'Analytics' },
      { icon: 'ri-git-compare-line', label: 'Comparison' },
      { icon: 'ri-file-search-line', label: 'Audit Logs' },
    ],
    codePreview: '',
    linkedin: {
      likes: 0,
      comments: 0,
      views: 0,
      url: ''
    }
  },
  {
    id: 'bitlocker-recovery-key-manager',
    name: 'BitLocker Recovery Key Manager',
    description: 'PowerShell script to retrieve and manage BitLocker recovery keys from Entra ID (formerly Azure AD). Supports bulk export, filtering by device name, and automated reporting for enterprise environments.',
    url: 'https://github.com/ozgurcebi/BitLocker-Key-Existence-Checker-for-Microsoft-Entra-ID',
    stars: 12,
    forks: 3,
    language: 'PowerShell',
    codePreview: `# BitLocker Recovery Key Manager
# Retrieve BitLocker recovery keys from Entra ID

Connect-MgGraph -Scopes "BitLockerKey.Read.All"

$devices = Get-MgDevice -All
foreach ($device in $devices) {
    $keys = Get-MgDeviceBitLockerRecoveryKey -DeviceId $device.Id
    Export-Csv -Path "BitLockerKeys.csv" -Append
}`,
    linkedin: {
      views: 8547,
      url: 'https://www.linkedin.com/posts/ozgurozturknet_bitlocker-recovery-key-manager-activity-7242464588033454080-nwXy'
    }
  }
];
